import { render, staticRenderFns } from "./GenericAlert.vue?vue&type=template&id=e605677e"
import script from "./GenericAlert.vue?vue&type=script&lang=ts"
export * from "./GenericAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports